/**
 * RFC 4122 UUID (any version), case-insensitive. Used to tell a real entity id
 * apart from a sentinel string carried in shared URL state — e.g. the contact
 * drawer reuses one `contactCollab` param for both a program id and a collab id,
 * and some rail rows seed it with a kind keyword ("collabs") that must never be
 * treated as a collab id and fetched.
 */
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Whether `value` is a well-formed UUID string. */
export const isUuid = (value: string | null | undefined): value is string =>
  typeof value === 'string' && UUID_RE.test(value);
